import React from 'react';
import {motion} from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const {FiPlay,FiTrendingUp,FiUsers,FiStar}=FiIcons;

const Hero=()=> {
  const scrollToForm=()=> {
    document.getElementById('signup-form').scrollIntoView({behavior: 'smooth'});
  };

  return ( 
    <section className="relative px-6 py-16 md:py-24 overflow-hidden"> 
      {/* Background decoration */} 
      <div className="absolute inset-0 -z-10"> 
        <div className="absolute top-20 left-10 w-72 h-72 bg-blue-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse"></div> 
        <div className="absolute top-40 right-10 w-72 h-72 bg-purple-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-1000"></div> 
        <div className="absolute bottom-20 left-1/2 w-72 h-72 bg-pink-200 rounded-full mix-blend-multiply filter blur-xl opacity-70 animate-pulse delay-2000"></div> 
      </div> 

      <div className="max-w-7xl mx-auto"> 
        <div className="text-center max-w-4xl mx-auto"> 
          {/* Trust badge */} 
          <motion.div 
            initial={{opacity: 0,y: 20}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 0.6}} 
            className="inline-flex items-center bg-gradient-to-r from-blue-600 to-purple-600 text-white px-6 py-2 rounded-full text-sm font-medium mb-8" 
          > 
            <SafeIcon icon={FiStar} className="mr-2" /> 
            Trusted by business owners for over a decade 
          </motion.div> 

          {/* Main headline */} 
          <motion.h1 
            initial={{opacity: 0,y: 30}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 0.8,delay: 0.2}} 
            className="text-5xl md:text-7xl font-bold text-gray-900 mb-6 leading-tight" 
          > 
            Unlock Your Business's 
            <span className="bg-gradient-to-r from-blue-600 to-purple-600 bg-clip-text text-transparent block"> 
              Circle of Goodness<sup className="text-sm">TM</sup> 
            </span> 
          </motion.h1> 

          {/* Subheadline */} 
          <motion.p 
            initial={{opacity: 0,y: 30}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 0.8,delay: 0.4}} 
            className="text-xl md:text-2xl text-gray-600 mb-8 leading-relaxed" 
          > 
            Transform your small business with our complete growth system. Get video tutorials,weekly group calls,templates,and step-by-step guides for social media,email marketing,and website optimization. 
          </motion.p> 

          {/* Value proposition */} 
          <motion.div 
            initial={{opacity: 0,y: 30}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 0.8,delay: 0.6}} 
            className="bg-white/80 backdrop-blur-sm border border-gray-200 rounded-2xl p-8 mb-10 shadow-xl" 
          > 
            <div className="grid md:grid-cols-3 gap-6"> 
              <div className="flex items-center justify-center md:justify-start"> 
                <SafeIcon icon={FiPlay} className="text-blue-600 text-2xl mr-3" /> 
                <span className="text-gray-700 font-medium">Video Tutorials</span> 
              </div> 
              <div className="flex items-center justify-center md:justify-start"> 
                <SafeIcon icon={FiUsers} className="text-purple-600 text-2xl mr-3" /> 
                <span className="text-gray-700 font-medium">Weekly Group Calls</span> 
              </div> 
              <div className="flex items-center justify-center md:justify-start"> 
                <SafeIcon icon={FiTrendingUp} className="text-green-600 text-2xl mr-3" /> 
                <span className="text-gray-700 font-medium">Growth Templates</span> 
              </div> 
            </div> 
          </motion.div> 

          {/* CTA */} 
          <motion.div 
            initial={{opacity: 0,y: 30}} 
            animate={{opacity: 1,y: 0}} 
            transition={{duration: 0.8,delay: 0.8}} 
            className="space-y-4" 
          > 
            <button 
              onClick={scrollToForm} 
              className="bg-gradient-to-r from-blue-600 to-purple-600 hover:from-blue-700 hover:to-purple-700 text-white text-xl font-bold px-12 py-4 rounded-full shadow-2xl hover:shadow-3xl transform hover:scale-105 transition-all duration-300" 
            > 
              Start Your FREE 7-Day Trial 
            </button> 
            <p className="text-gray-500 text-sm"> 
              No credit card required • Cancel anytime • Full access for 7 days 
            </p> 
          </motion.div> 

          {/* Social proof */} 
          <motion.div 
            initial={{opacity: 0}} 
            animate={{opacity: 1}} 
            transition={{duration: 1,delay: 1}} 
            className="mt-16 grid grid-cols-2 md:grid-cols-4 gap-8 opacity-60" 
          > 
            <div className="text-center"> 
              <div className="text-3xl font-bold text-gray-800">800+</div> 
              <div className="text-sm text-gray-600">Success Stories</div> 
            </div> 
            <div className="text-center"> 
              <div className="text-3xl font-bold text-gray-800">95%</div> 
              <div className="text-sm text-gray-600">Success Rate</div> 
            </div> 
            <div className="text-center"> 
              <div className="text-3xl font-bold text-gray-800">4.9★</div> 
              <div className="text-sm text-gray-600">User Rating</div> 
            </div> 
            <div className="text-center"> 
              <div className="text-3xl font-bold text-gray-800">50+</div> 
              <div className="text-sm text-gray-600">Templates and Resources</div> 
            </div> 
          </motion.div> 
        </div> 
      </div> 
    </section> 
  );
};

export default Hero;